import { getContentGroupList, addContentGroup, editContentGroup } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'contentGroupManagement',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *getContentGroupList({ payload }, { call, put }) {
      const res = yield call(getContentGroupList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveContentList',
          payload: res.data,
        });
      }
      return res;
    },
    *addContentGroup({ payload }, { call }) {
      return yield call(addContentGroup, payload);
    },
    *editContentGroup({ payload }, { call }) {
      return yield call(editContentGroup, payload);
    },
  },
  reducers: {
    saveContentList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
